import { NavLink } from "react-router-dom";
import { Home, ShoppingCart, FileText, MoreHorizontal } from "lucide-react";
import type { AuthUser } from "@/hooks/useAuth";
import { cn } from "@/lib/utils";

interface BottomNavProps {
  user: AuthUser;
}

export function BottomNav({ user }: BottomNavProps) {
  const items = [
    { to: "/",              label: "Inicio",  icon: Home },
    { to: "/ventas",        label: "Ventas",  icon: ShoppingCart },
    { to: "/cuentas-cobro", label: "Cortes",  icon: FileText },
    { to: user.rol === "admin_central" ? "/admin/kanban" : "/config", label: "Más", icon: MoreHorizontal },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-20 bg-bg-card border-t border-border">
      <ul className="grid grid-cols-4">
        {items.map(({ to, label, icon: Icon }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={to === "/"}
              className={({ isActive }) =>
                cn(
                  "flex flex-col items-center justify-center gap-1 py-2.5 text-xs",
                  isActive ? "text-brand" : "text-fg-secondary",
                )
              }
            >
              <Icon className="size-5" />
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
